import React, { useState, useEffect, useContext } from "react";
import ActionsContext from "common/ActionsContext";
import styled from "styled-components";
import DataTable, { Column } from "common/DataTable";
import Request from "common/Request";
import { askConfirmation, mayDecline } from "common/AskConfirmation";

const doesNothing = () => {};

const userActions = (_row, send) => [
  {
    id: "send-update-password",
    label: "Change Password",
    icon: "lock",
    onClick: (user) => send("change-password", { user }),
  },
  {
    id: "send-delete-user",
    label: "Delete",
    icon: "delete",
    onClick: (user) => send("delete-user", { user }),
  },
];

const TableContainer = styled.div`
  width: 100%;
  overflow: auto;
`;

const noRoot = ([username]) => username !== "root";

const UsersList = ({ response, send = doesNothing }) => (
  <TableContainer>
    <DataTable
      pageLength={50}
      exportAsCSV={true}
      content={response}
      filters={[noRoot]}
      columns={[
        Column.Text({
          label: "USERNAME",
          idx: 0,
        }),
        Column.Text({
          label: "PROFILE",
          idx: 1,
        }),
        Column.TextTillEnd({
          label: "DESCRIPTION",
          idx: 2,
        }),
        Column.Actions({
          label: "ACTIONS",
          idx: 0,
          are: (source, row) => userActions(row, send),
          colClassName: "text-center action",
          cellClassName: "hides-content-to-operators",
        }),
      ]}
    />
  </TableContainer>
);

const avoidWarningByCrontab = response =>
  response.match(/no contrab for /) !== null

const existsAndNotAvoidable = (response, ...exceptions) =>
  response && response.length > 0 && exceptions.find(exceptional => exceptional(response)) !== undefined

const reportIfFailsDuring = (action, process) =>
  process
    .then((response) => {
      if (existsAndNotAvoidable(response, avoidWarningByCrontab)) {
        console.log("user.<%s>.error: <%s>", action, response);
        throw `Warning: ${response}`;
      }
    })
    .catch(window.showModalError);

const doRemoveUser = (user) =>
  reportIfFailsDuring("delete", ifCl.run(`system users delete ${user} force`));

const removeUser = (user) =>
  askConfirmation(
    `Delete "${user}" user?'`,
    "<b>WARNING</b>: The user will be permanently deleted " +
      "together with all the files inside its home directory.",
    { icon: "delete_forever" }
  ).then(() => doRemoveUser(user));

const ListUsers = () => {
  const [request, setRequest] = useState(null);
  const actions = useContext(ActionsContext);

  const sendSignal = (...args) => actions.send(...args);

  const doRequest = () =>
    ifCl.run("show system users").then( response => ({response}) );

  const doLoad = () => {
    setRequest(doRequest());
  };
  useEffect(
    () =>
      actions.recv("delete-user", ({ user }) =>
        removeUser(user).then(doLoad).catch(mayDecline)
      ),
    []
  );

  useEffect(() => (doLoad(), actions.recv("do-load", doLoad)), []);

  return request === null ? null : (
    <Request during={request}>
      {(result) => (
        <>
          <UsersList {...result} send={sendSignal} />
        </>
      )}
    </Request>
  );
};

export default ListUsers;
